import React, { Component } from 'react';
import TopBar from '../../component/top-bar/top-bar.component';
import apiManage from '../../request';
import { getQueryString } from '../../constants/tool-get-parms';
import { Customer, Dish, Restaurant, ScheduleTimeRange, SettingClosedSchedule } from '../../models';
import Store from '../../rudex/store';
import _ from 'lodash';
import { createHashHistory } from 'history';
import { ParkModeHeader } from './park-project';
import i18n from '../../i18n';
import './scss/park-mode.scss';
import MenuList from '../../component/order/menu-list/menu-list.component';
import { DishFixed } from '../../models/fixed/dish.entity';
import { ScrollParams } from 'react-virtualized';
import { debounce } from '../../component/decorators/helper.decorator';
import BScroll from 'better-scroll';
import { ArrowBackIos } from '@material-ui/icons';
import ParkProjectCart, { ProjectTime } from './park-project-cart';
import { CartDefaultData, ParkProject } from './type';
import moment from 'moment';
import { LOCAL_STORAGE_KEYS } from '../../constants/local-storage.constant';
import { LocalStorageManager } from '../../constants/tool-local-storage';
import { convertDateByTimeZoneName } from '../../constants/tool-constant';
import momentTimeZone from 'moment-timezone';
import { getParkSchedule } from '../../constants/tool-update-schedule-data';
const history = createHashHistory();

class ParkModePage extends Component {

    // 菜品列表ref
    public menuListRef: MenuList | null = null;
    public requesting: boolean = false;
    public SlideScroll: BScroll | undefined;
    state: State = {
        showView: 0,
        stringId: getQueryString('string_id') || '',
        restaurantInfo: {},
        cart: {},
        projectListData: [],
        listHeight: [],
        // slideData: [],
        dishListClientHeight: 0,
        timeRange: null,
        selectDate: undefined,
        step: 1,
        projectTimeDefaultData: {},
        timeRanges: [],
        cartDefaultData: {},
        account: {},
        privacyPolicyList: {
            ruleClauses: {
                title: '',
                content: ''
            },
            privacyPolicy: {
                title: '',
                content: ''
            },
            disclaimer: {
                title: '',
                content: ''
            }
        }
    }

    async componentDidMount() {
        await this.init();
    }
    async init() {
        this.getAccount();
        await this.getParkModeData();
        this.getHeightList();
        await this.getPrivacyPolicy();

    }
    async getPrivacyPolicy() {
        const api1 = apiManage.getRuleClauses(this.state.stringId);
        const api2 = apiManage.getPrivacyPolicy(this.state.stringId);
        const api3 = apiManage.getDisclaimer(this.state.stringId);
        const [ruleClauses, privacyPolicy, disclaimer] = await Promise.all([api1, api2, api3]);
        try {
            this.setState({
                privacyPolicyList: {
                    ruleClauses: {
                        title: ruleClauses.rule_title,
                        content: ruleClauses.rule_content?.text || ''
                    },
                    privacyPolicy: {
                        title: i18n.t('park_mode_text_privay_policy'),
                        content: privacyPolicy.privacy_policy_content?.text || ''
                    },
                    disclaimer: {
                        title: i18n.t('prk_mode_text_disclaimer'),
                        content: disclaimer.disclaimer_content?.text || ''
                    },
                }
            })
        } catch (error) {

        }
    }
    async getAccount() {
        const cacheAccount: Customer = await LocalStorageManager.getLocalStorage(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        this.setState({
            account: cacheAccount
        })
    }
    async getParkModeData() {
        const restaurantApi = apiManage.getRestaurantInfo(this.state.stringId);
        const projectApi = apiManage.getParkModeProject(this.state.stringId);
        // 同时请求
        const [restaurantRes, projectRes] = await Promise.all([restaurantApi, projectApi]);
        if (restaurantRes?.dbResults?.[0] && projectRes.dbResults) {
            // 过滤下架的商品 status:'1'
            const projectListData = projectRes.dbResults.filter((item) => item.status !== '1');

            this.setState({
                showView: 1,
                restaurantInfo: restaurantRes.dbResults[0],
                projectListData
            }, () => {
                // this.onSelectDateBefore();
            })
        } else {
            this.setState({
                showView: 2
            })
        }
    }


    onshowDishDetails(dish: Dish, index: number, isShow: boolean) {
        this.setState({
            cart: dish,
            projectTimeDefaultData: {
                timeRange: undefined,
                selectDate: this.state.projectTimeDefaultData?.selectDate
            }
        })
        const selectDate = this.state.projectTimeDefaultData?.selectDate;
        this.onSelectDateBefore(selectDate, dish, () => {
            this.menuListRef?.trigger(index, isShow);
        });
    }
    /**
     * 列表滚动时触发
     */
    onScroll(position: ScrollParams) {
        const scrollTop = Math.abs(Math.round(position.scrollTop + 3))
        // console.log(scrollTop, position);
        this.getCurrentIndex(scrollTop);
    }
    /**
     * 获取菜品分类title的高度,并初始化滚动插件
     */
    getHeightList() {
        const newlistHeight: Array<number> = [];
        let height = 0;
        newlistHeight.push(height);
        const wrapper: Element | null = document.querySelector('#main_container_dish_list');
        const innerWidth = window.innerWidth;
        this.state.projectListData?.forEach(() => {
            height += (1) * (250 / 1080 * innerWidth) + 42;
            newlistHeight.push(Number(height.toFixed(2)));
        })
        this.setState({
            listHeight: newlistHeight,
            dishListClientHeight: wrapper?.clientHeight || 0
        }, () => {
            // 加载第一可视区域的菜品图片
            this.getCurrentIndex(0);
        })
    }

    /**
     * 滑动菜品，自动选中一级菜单
     */
    @debounce(1000)
    async getCurrentIndex(scrollY: number) {
        try {
            if (this.requesting) return
            let scrollIndex: number;
            let viewableAreaIndex: number[] = [];
            const { listHeight, /* slideData, */ dishListClientHeight } = this.state;
            // 可视范围，看到的所有菜品title
            listHeight.forEach((height, hIndex) => {
                if ((height > scrollY) && (height < (dishListClientHeight + scrollY))) {
                    viewableAreaIndex.push(hIndex);
                }
            })
            scrollIndex = _.sortedIndex(listHeight, scrollY) - 1;
            scrollIndex = scrollIndex < 0 ? 0 : scrollIndex;
            viewableAreaIndex.unshift(scrollIndex);
            this.requesting = true;
            // 加载多上下各一屏的菜品图片
            const next = Array.from({ length: viewableAreaIndex.length }, (_, i) => i + viewableAreaIndex[viewableAreaIndex.length - 1] + 1);
            const last = Array.from({ length: viewableAreaIndex.length }, (_, i) => viewableAreaIndex[0] - i - 1);
            viewableAreaIndex = [...last, ...viewableAreaIndex, ...next];
            // 过滤大于0的
            viewableAreaIndex = viewableAreaIndex.filter((item) => item >= 0);
            const dishIds = this.state.projectListData.reduce<string[]>((previousValue, currentValue: ParkProject, currentIndex: number,) => {
                if (viewableAreaIndex.includes(currentIndex) && currentValue._id && !currentValue.realpics) {
                    return [...previousValue, currentValue._id]
                } else {
                    return [...previousValue]
                }
            }, [])

            if (dishIds.length > 0) {
                // 可视区域的菜品获取图片
                this.getProjectPic(dishIds);
            }
            this.requesting = false
        } catch (error) { }
    }
    /**
     * 获取项目图片
     * @returns 
     */
    async getProjectPic(dishIds: string[]) {
        // 
        const picArr = await apiManage.getSetDishImg(this.state.stringId, dishIds, { notNeedLoading: true });
        if (!picArr?.error) {
            const { projectListData } = this.state;
            projectListData.forEach((item) => {
                const url = picArr.find((picItem) => picItem._id === item._id)?.picUrl;
                if (url) {
                    item.realpics = url ? [url] : undefined;
                }
            })
            this.setState({
                projectListData: projectListData
            })
        }
    }

    // 设置并显示所选日期的可预约时间段
    setTimePeriod(week: number, selectDateFormat: string) {
        try {
            const { setting_booking_service_schedule: bookingServiceSchedule, setting_booking_no_service_schedule: disabledDates,
                time_zone
            } = this.state.restaurantInfo;
            const restaurantsTimeZoneName = time_zone || momentTimeZone.tz.guess()
            // 当前时区
            const originTimeZoneName = momentTimeZone.tz.guess();
            // $ 将本地当前时间转化为餐馆时区的时间
            let currentTime = moment(new Date()).format(moment.defaultFormatUtc);
            currentTime = convertDateByTimeZoneName(currentTime, originTimeZoneName, restaurantsTimeZoneName);
            currentTime = moment(currentTime, moment.defaultFormatUtc).format('YYYY-MM-DD HH:mm');

            // 这一天不可以预定的开始时间
            let closeStartTime = '';
            // 这一天不可以预定的结束时间
            let closeEndTime = '';
            // 闭店时间范围：开始结束不是同一天
            if (disabledDates) {
                const cloneDisabledDates = _.cloneDeep(disabledDates)
                const selectCloseDate = _.filter(cloneDisabledDates, (item) => {
                    const start_date = item.start_date && this.formateDate(item.start_date, 'YYYY-MM-DD')
                    const end_date = this.formateDate(item?.end_date, 'YYYY-MM-DD')
                    return (moment(selectDateFormat).isBetween(start_date, end_date, 'date', '[]')
                        && (start_date !== end_date));
                })
                if (selectCloseDate) {
                    let newCloseStartTime = '';
                    let newCloseEndTime = '';
                    selectCloseDate.forEach((item) => {
                        const newStartDate = moment(item.start_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')
                        const newEndDate = moment(item.end_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')

                        if (moment(selectDateFormat).isSame(newStartDate)) {
                            if (newCloseStartTime) {
                                const start_time = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                                if (moment(newCloseStartTime).isAfter(start_time)) {
                                    newCloseStartTime = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                                }
                            } else {
                                newCloseStartTime = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                            }
                        }
                        if (moment(selectDateFormat).isSame(newEndDate)) {
                            if (newCloseEndTime) {
                                const start_time = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                                if (moment(newCloseEndTime).isBefore(start_time)) {
                                    newCloseEndTime = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                                }
                            } else {
                                newCloseEndTime = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                            }
                        }
                    })
                    closeStartTime = newCloseStartTime;
                    closeEndTime = newCloseEndTime;
                }
            }
            // 闭店时间范围：开始结束都是同一天的
            let sameCloseDate: SettingClosedSchedule[] = []
            if (disabledDates) {
                const cloneDisabledDates = _.cloneDeep(disabledDates)
                sameCloseDate = _.filter(cloneDisabledDates, (item) => {
                    const start_date = item.start_date && this.formateDate(item.start_date, 'YYYY-MM-DD')
                    const end_date = this.formateDate(item?.end_date, 'YYYY-MM-DD')
                    return (moment(selectDateFormat).isBetween(start_date, end_date, 'date', '[]')
                        && (start_date === end_date));
                })
            }
            // 赋予预约详细时间段按钮 selectKey、disabled
            const cloneBookingServiceSchedule = _.cloneDeep(bookingServiceSchedule)
            // 找出选择的日期的所对应的周几
            const scheduleItem = _.find(cloneBookingServiceSchedule, (n) => { return n.week === week })
            let booking_time_interval = scheduleItem?.booking_time_interval || []
            if (booking_time_interval && booking_time_interval.length > 0) {
                booking_time_interval = booking_time_interval.map((n, nameIndex) => {
                    if (n.time_interval_detail && n.time_interval_detail.length > 0) {
                        n.time_interval_detail.map((v, timeIndex) => {
                            // 设置时间段按钮的key、disabled
                            _.set(v, 'selectKey', `${nameIndex}-${timeIndex}`)
                            _.set(v, 'disabled', false)
                            const start_time = moment(v.start_time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                            const end_time = moment(v.end_time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                            // 将闭店开始时间之后的时间段设置不可点击
                            if (closeStartTime && (moment(closeStartTime).isSameOrBefore(start_time))) {
                                _.set(v, 'disabled', true)
                            }
                            // 将闭店结束时间之前的时间段设置不可点击
                            if (closeEndTime && (moment(closeEndTime).isSameOrAfter(end_time))) {
                                _.set(v, 'disabled', true)
                            }
                            // 设置选择的日期的闭店时间段设置不可点击
                            if (sameCloseDate.length > 0) {
                                sameCloseDate.forEach((item) => {
                                    const endTimeInterval = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                                    const startTimeInterval = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                                    if (
                                        moment(start_time).isBetween(endTimeInterval, startTimeInterval,
                                            'minutes', '[]')
                                        && moment(end_time).isBetween(endTimeInterval, startTimeInterval, 'minutes', '[]')
                                    ) {
                                        _.set(v, 'disabled', true)
                                    }
                                })
                            }
                            // 开始时间在现在时间之前设置不可点击
                            if (moment(`${selectDateFormat} ${v.start_time}`).isBefore(currentTime)) {
                                _.set(v, 'disabled', true);
                            }
                            return v
                        })
                    }
                    return n
                })
            }
            return booking_time_interval

        } catch (error) {
            return []
        }
    }
    // 点击日历日期
    onSelectDateBefore(date?: string, itemData?: ParkProject, callback?: () => void) {

        let times: string[] = [];
        // 活动开关 undefined\0:开启 1:关闭
        if (this.state.restaurantInfo?.is_setting_restaurant_amusement_open_time === '1') {
            times = [];
        }
        // 目标项目中是否有特定营业时间
        else if (itemData?.business_hours) {
            times = itemData?.business_hours[moment(date ?? moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').isoWeekday().toString()] || [];
        }
        // 没有则用公共的营业时间 
        else {
            times = this.state.restaurantInfo?.setting_restaurant_amusement_open_time || [];
        }

        let timeRanges = getParkSchedule(times);
        // 如果date不是今天，当前时间小于时间点  disabled为false
        if (date && !moment().isSame(moment(date, 'DD/MM/YYYY'), 'date')) {
            timeRanges = timeRanges.map((item) => {
                item.disabled = false;
                return item;
            })
        }
        this.setState({ timeRanges }, () => {
            callback?.()
        })
    }
    // onSelectDateBefore(date?: string, callback?: () => void) {
    //     try {
    //         const selectDateFormat = moment(date, date ? 'DD/MM/YYYY' : undefined).format('YYYY-MM-DD');
    //         const week = moment(selectDateFormat, 'YYYY-MM-DD').isoWeekday();
    //         const bookingTimeInterval = this.setTimePeriod(week, selectDateFormat);
    //         const timeRanges = bookingTimeInterval.reduce<{
    //             start_time?: Date;
    //             end_time?: Date;
    //         }[]>((pre, cur) => {
    //             if (cur.time_interval_detail) {
    //                 return [...pre, ...cur.time_interval_detail]
    //             } else {
    //                 return [...pre]
    //             }
    //         }, [])
    //         // 排序开始时间从小到大
    //         timeRanges.sort((a, b) => {
    //             return moment(a.start_time, 'HH:mm').isBefore(moment(b.start_time, 'HH:mm')) ? -1 : 1;
    //         })
    //         // 最多24个时间
    //         timeRanges.splice(24);
    //         this.setState({ timeRanges }, () => {
    //             callback?.()
    //         })
    //     } catch (error) {

    //     }
    // }
    /**
     * 格式化日期
     * @param date 日期
     * @param format 要转换的格式
     */
    formateDate(date: string | undefined, format: string) {
        return date ? moment(date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format(format) : ''
    }

    /**
     * 选择项目
     */
    confirm(timeRange: ScheduleTimeRange, selectDate: string) {
        const { account, cart, cartDefaultData } = this.state;
        if (account._id) {
            // 确保 timeRange 选的是 timeRanges 中的
            if (!this.state.timeRanges.find((item) => item.start_time === timeRange.start_time)) {
                return;
            }
            // 切换了项目，就要清空已经填写的信息
            if (cart._id !== cartDefaultData.projectDetail?._id) {
                // 获取账号信息，填写默认信息
                const accountInfo = LocalStorageManager.getLocalStorage(LOCAL_STORAGE_KEYS.ACCOUNT);
                this.setState({
                    cartDefaultData: {
                        projectDetail: cart,
                        creatorInfo: {
                            firstName: accountInfo?.first_name,
                            lastName: accountInfo?.last_name,
                            phone: accountInfo?.phone,
                            phonePrefix: accountInfo?.phone_prefix,
                            email: accountInfo?.email,
                            birth: accountInfo?.birth ? moment(accountInfo?.birth).format('DD/MM/YYYY') : undefined,
                        },
                        participants: [],
                        agreements: undefined
                    }
                });
            }
            this.setState({ timeRange, selectDate, step: 2 });
        } else {
            history.push('/sign-in');
        }
    }

    render() {
        const { showView, restaurantInfo, stringId, projectListData, cart, step, projectTimeDefaultData, timeRanges, cartDefaultData } = this.state;
        const merchantWebsite = _.get(Store.getState(), 'merchantWebsite')
        return (
            <div className='park-mode-page'>
                {showView !== 2 ?
                    <TopBar
                        isHideMenu={false}
                        title={restaurantInfo.nickname || ''}
                        isGoBack={() => history.push(`/restaurantPage?string_id=${stringId}${merchantWebsite ? '&merchant_website=true' : ''}`)}
                    /> : null}

                <div className={`order_main_container `}
                    style={{
                        visibility: showView === 1 ? 'visible' : 'hidden',
                    }}>
                    <div className='main_container_header'>
                        <ParkModeHeader
                            orderHeaderData={{
                                title: i18n.t('park_mode_text_chose_project'),
                                leftIcon: step > 1 ? () => <ArrowBackIos /> : undefined
                            }}
                            handleLeftBtn={() => {
                                this.setState({
                                    step: step - 1
                                })
                            }}

                        />
                    </div>
                    <div id='main_container_dish_list'
                        className={`main_container_dish_list  `} >
                        {/* 项目列表 */}
                        {
                            <MenuList
                                ref={(refs) => this.menuListRef = refs}
                                dishList={projectListData as DishFixed[]}
                                updateShopCatList={(/* updateItem, status */) => {
                                }}
                                saveShopCatDate={[]}
                                onshowDishDetails={(dishes, index, isShow) => this.onshowDishDetails(dishes, index, isShow)}
                                onScroll={this.onScroll.bind(this)}

                                orderType={'3'}
                                openSchedulesModel={(dishSchedules) => {
                                    this.setState({ isOpenSchedulesModel: true, dishSchedules })
                                }}
                                collapseRenderer={(itemData, index, collapse) => (
                                    <ProjectTime
                                        collapse={collapse}
                                        timeRanges={timeRanges}
                                        defaultData={projectTimeDefaultData || {}}
                                        maxDate={this.state.restaurantInfo?.setting_max_booking_day ?? 14}
                                        onConfirm={(timeRange, selectDate) => {
                                            this.confirm(timeRange, selectDate);
                                        }}
                                        onSelectDate={(selectDate) => {
                                            this.onSelectDateBefore(selectDate, itemData, () => {
                                                this.menuListRef?.trigger(index, true);
                                            });
                                        }}
                                        onChange={(timeRange, selectDate) => {
                                            this.setState({
                                                projectTimeDefaultData: {
                                                    timeRange: timeRange,
                                                    selectDate: selectDate
                                                }
                                            })
                                        }}
                                    />)
                                }
                            />
                        }
                        {/* 暂无数据 */}
                        {(projectListData.length === 0 &&
                            <div className='no_related_date' style={{ position: 'absolute' }}>
                                {i18n.t('general_text_no_relevant_data')}
                            </div>)}
                    </div >

                    {/* 购物车-项目填写信息 */}
                    {
                        <ParkProjectCart
                            show={step === 2}
                            projectDetail={cart}
                            selectedDateTime={{
                                startDateTime: `${moment(this.state.selectDate, 'DD/MM/YYYY').format('YYYY-MM-DD')} ${this.state.timeRange?.start_time}`,
                                endDateTime: `${moment(this.state.selectDate, 'DD/MM/YYYY').format('YYYY-MM-DD')} ${this.state.timeRange?.end_time}`,
                            }}
                            defaultData={cartDefaultData}
                            onHoldData={(data) => {
                                this.setState({
                                    cartDefaultData: data,
                                });
                            }}
                            privacyPolicyList={this.state.privacyPolicyList}
                            goBack={() => {
                                this.setState({
                                    step: 1
                                })
                            }}
                        />
                    }
                </div >
            </div >
        )
    }
}

export default ParkModePage


type State = {
    showView: number;
    stringId: string;
    restaurantInfo: Restaurant;
    cart: ParkProject;
    projectListData: ParkProject[];
    listHeight: number[];
    dishListClientHeight: 0;
    timeRange: { start_time: string, end_time: string, disabled: boolean } | null;
    selectDate: Date | undefined;
    step: number;
    projectTimeDefaultData: { timeRange?: { start_time: string, end_time: string }, selectDate?: string };
    timeRanges: { start_time: string, end_time: string, disabled: boolean }[];
    cartDefaultData: CartDefaultData;
    account: Customer;
    privacyPolicyList: {
        ruleClauses: {
            title: string,
            content: string
        },
        privacyPolicy: {
            title: string,
            content: string
        },
        disclaimer: {
            title: string,
            content: string
        }
    }
}
